module.exports = __webpack_public_path__ + "static/img/logo.df719a2.png";


//////////////////
// WEBPACK FOOTER
// ./static/logo.png
// module id = 7Ogj
// module chunks = 21